import React, { useState, useEffect } from 'react';
import { Form, FormGroup, Label, Col, Button, Input, Row, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import DataTable from 'react-data-table-component';
import SelectTenableNet from "../BasicComponents/SelectTenableNet";
import SelectTenableUnit from "../BasicComponents/SelectTenableUnit";
import SelectTenableUrl from "../BasicComponents/SelectTenableUrl";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { api_url } from "../globalFunction/global_string";
import { SiteTitle } from "../SiteTitle";
import Swal from 'sweetalert2';
import { SelectName } from "../BasicComponents/SelectName";


const RiskHeader = ({ title, color }) => (
    <div style={{
        display: 'inline-block',
        backgroundColor: color,
        padding: '10px',
        borderRadius: '0px',
        color: 'white',
        margin: '0px'
    }}>
        {title}
    </div>
);

function TenableHistoryData() {
    const [fileLoading, setFileLoading] = useState(false);
    const [historyRecords, setHistoryRecords] = useState([]);
    const [selectedNet, setSelectedNet] = useState('');
    const [localNetName, setLocalNetName] = useState('');
    const [selectedUnit, setSelectedUnit] = useState('');
    const [localUnitName, setLocalUnitName] = useState('');
    const [selectedUrl, setSelectedUrl] = useState('');
    const [localUrlName, setLocalUrlName] = useState('');
    const [selectedUser, setSelectedUser] = useState('');
    const [localUserName, setLocalUserName] = useState('');
    const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false); // 管理 Modal 開關狀態
    const [isScanInfoModalOpen, setIsScanInfoModalOpen] = useState(false); // 新增 ScanInfo Modal 的狀態
    const [modalData, setModalData] = useState({});
    const [scanInfoData, setScanInfoData] = useState({});
    const [currentGuid, setCurrentGuid] = useState('');
    const [scanname, setScanname] = useState('');
    const [netName, setNetName] = useState(localStorage.getItem('login_user_net_name'));
    const [unitName, setUnitName] = useState(localStorage.getItem('login_local_unit_name'));
    const [userType, setuserType] = useState(localStorage.getItem('login_user_type'));
    useEffect(() => {
        const storedHistoryData = sessionStorage.getItem('CurrentHistoryData');
        if (storedHistoryData) {
            const parsedData = JSON.parse(storedHistoryData);

            const sortedData = parsedData.sort((a, b) => parseInt(a.historyNumber) - parseInt(b.historyNumber));

            setHistoryRecords(sortedData);
        }
    }, []);


    const handleNetSelectChange = (data) => {
        const { value, selectedName } = data;
        setSelectedNet(value);
        setLocalNetName(selectedName);
        setSelectedUnit('');
        setLocalUnitName('');
    };

    const handleUnitSelectChange = (data) => {
        const { value, selectedName } = data;
        setSelectedUnit(value);
        setLocalUnitName(selectedName);
    };

    const handleUrlSelectChange = (data) => {
        const { value, selectedName } = data;
        setSelectedUrl(value);
        setLocalUrlName(selectedName);
        console.log(value)
        console.log(selectedName)
    };

    // 處理人員選擇
    const handleUserSelectChange = (data) => {
        const { value, selectedName } = data;
        setSelectedUser(value);
        setLocalUserName(selectedName);
        console.log(value)
        console.log(selectedName)

    };
    // 下載報告
    const DownLoadPaper = async (scan_id) => {
        setFileLoading(true);
        const apiUrl = api_url + "/api/TEN/CheckAndDownloadReportAsync";
        const formData = new FormData();
        formData.append("scan_id", scan_id);

        try {
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Authorization": localStorage.getItem('accessToken')
                },
                body: formData
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            console.log('API Response Data:', data);
            let arr_status = [String(data.statusCode), data.row, data.detail];
            const row = arr_status[1] !== null && arr_status[1] !== '' ? arr_status[1] : '';

            const regex = /\/[^\/]+\/[^\/]+\.zip/;
            const match = row.replace(/\\/g, '/').match(regex);
            const converted = match ? match[0] : '';

            console.log('Converted:', converted);

            const fileUrl = `${api_url}${converted}`;
            const fileResponse = await fetch(fileUrl);

            if (!fileResponse.ok) {
                throw new Error(`HTTP error! status: ${fileResponse.status}`);
            }

            const blob = await fileResponse.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;

            // 提取純檔案名稱
            const finalFileName = converted.substring(converted.lastIndexOf('/') + 1);
            console.log('Final FileName:', finalFileName);

            a.download = finalFileName;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Error:', error);
        } finally {
            setFileLoading(false);
        }
    }

    //寄送密碼的MODAL內容
    const renderPasswordModalContent = () => {
        switch (userType) {
            case "S":
                return (
                    <>
                        <FormGroup row>
                            <Label sm={3} className="text-right">區網名稱</Label>
                            <Col sm={7}>
                                <SelectTenableNet
                                    parentName={'superS'}
                                    id={'excel_net_name'}
                                    name={'excel_net_name'}
                                    requiredAPI={'/api/JRCC/GetLocalNetId'}
                                    handleNetSelectChange={handleNetSelectChange}
                                    style={{ width: '50%' }}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="excel_unit_name" sm={3} className="text-right">單位名稱</Label>
                            <Col sm={7}>
                                <SelectTenableUnit
                                    parentName={'superS'}
                                    id={'excel_unit_name'}
                                    name={'excel_unit_name'}
                                    requiredAPI={'/api/Async/GetNetDownUnitlist'}
                                    handleUnitSelectChange={handleUnitSelectChange}
                                    selectnet={selectedNet}
                                    local_net_name={localNetName}
                                    style={{ width: '50%' }}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="local_user_id" sm={3} className="text-right">人員資料</Label>
                            <Col sm={7}>
                                <SelectName
                                    parentName={'superS'}
                                    id={'excel_user_name'}
                                    name={'excel_user_name'}
                                    requiredAPI={'/api/Async/GetUserdatalist'}
                                    handleUserSelectChange={handleUserSelectChange}
                                    selectedUnitproxy={selectedUnit}
                                    local_unit_proxy_name={localUnitName}
                                    selectnet={selectedNet}
                                    local_net_name={localNetName}
                                    style={{ width: '50%' }}
                                />
                            </Col>
                        </FormGroup>
                    </>
                );
            case "M":
                return (
                    <>
                        <FormGroup row>
                            <Label sm={3} className="text-right">區網名稱</Label>
                            <Col sm={7} className="d-flex align-items-center">
                                <p className="mb-0">{netName}</p>
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="excel_unit_name" sm={3} className="text-right">單位名稱</Label>
                            <Col sm={7}>
                                <SelectTenableUnit
                                    parentName={'superM'}
                                    id={'excel_unit_name'}
                                    name={'excel_unit_name'}
                                    requiredAPI={'/api/Async/GetNetDownUnitlist'}
                                    handleUnitSelectChange={handleUnitSelectChange}
                                    selectnet={localStorage.getItem('login_user_net_id')}
                                    local_net_name={localStorage.getItem('login_user_net_name')}
                                    style={{ width: '50%' }}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row inline>
                            <Label for="local_user_id" sm={2}>人員資料</Label>
                            <Col sm={10}>
                                <SelectName
                                    parentName={'superM'}
                                    id={'excel_user_name'}
                                    name={'excel_user_name'}
                                    requiredAPI={'/api/Async/GetUserdatalist'}
                                    handleUserSelectChange={handleUserSelectChange}
                                    selectedUnitproxy={selectedUnit}
                                    local_unit_proxy_name={localUnitName}
                                    selectnet={localStorage.getItem('login_user_net_id')}
                                    local_net_name={netName}
                                    style={{ width: '50%' }}
                                />
                            </Col>
                        </FormGroup>
                    </>
                );
            case "N":
                return (
                    <>
                        <FormGroup row className="d-flex align-items-center">
                            <Label sm={3} className="text-right">區網名稱</Label>
                            <Col sm={7} className="d-flex align-items-center">
                                <p className="mb-0">{netName}</p>
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label sm={3} className="text-right">單位名稱</Label>
                            <Col sm={7} className="d-flex align-items-center">
                                <p className="mb-0">{netName}</p>
                            </Col>
                        </FormGroup>
                        <FormGroup row inline>
                            <Label for="local_user_id" sm={2}>人員資料</Label>
                            <Col sm={10}>
                                <SelectName
                                    parentName={'superN'}
                                    id={'excel_user_name'}
                                    name={'excel_user_name'}
                                    requiredAPI={'/api/Async/GetUserdatalist'}
                                    handleUserSelectChange={handleUserSelectChange}
                                    style={{ width: '50%' }}
                                />
                            </Col>
                        </FormGroup>
                    </>
                );
            default:
                return <div>沒有可用的表單內容</div>;
        }
    };

    //寄送報告密碼
    const handleSendReportPassword = async () => {
        const apiUrl = `${api_url}/api/async/SendReportPaswword`;
        const formData = new FormData();

        // 根據不同的 userType 檢查輸入欄位
        if (userType === "S") {
            if (!selectedNet || !selectedUnit || !selectedUser) {
                Swal.fire("錯誤", "請選擇所有必要的選項。", "error");
                return;
            }
        } else if (userType === "M") {
            if (!selectedUnit || !selectedUser) {
                Swal.fire("錯誤", "請選擇所有必要的選項。", "error");
                return;
            }
        } else if (userType === "N") {
            if (!selectedUser) {
                Swal.fire("錯誤", "請選擇所有必要的選項。", "error");
                return;
            }
        }

        // 準備表單資料
        formData.append("send_user_id", localStorage.getItem('login_user_id'));
        formData.append("local_net_id", selectedNet);
        formData.append("local_unit_id", selectedUnit);
        formData.append("user_id", selectedUser);
        formData.append("currentGuid", modalData.id); // 使用 modalData 中的 id
        formData.append("scanname", modalData.scanname); // 使用 modalData 中的 scanname
        formData.append("net_name", modalData.net_name); // 使用 modalData 中的 net_name
        formData.append("unit_name", modalData.unit_name); // 使用 modalData 中的 unit_name
        formData.append("type", "TEN");
        try {
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Authorization": localStorage.getItem('accessToken') },
                body: formData,
            });

            const data = await response.json();

            if (data.statusCode === 200) {
                Swal.fire("成功", "報告密碼寄送成功。", "success");
                togglePasswordModal(); // 成功後關閉 Modal
            } else {
                Swal.fire("錯誤", "寄送失敗，請重試。", "error");
            }
        } catch (error) {
            console.log('Error fetching JSON:', error);
        }
    };

    const togglePasswordModal = () => {
        setIsPasswordModalOpen(!isPasswordModalOpen);
    };

    // 切換 ScanInfo Modal 開關狀態
    const toggleScanInfoModal = () => {
        setIsScanInfoModalOpen(!isScanInfoModalOpen);
    };

    const handleShowPasswordModal = (id, scanname, net_name, unit_name) => {
        setModalData({ id, scanname, net_name, unit_name }); // 設定 Modal 需要的數據
        togglePasswordModal(); // 開啟 Modal
    };


    const formatBuildDate = (date) => {
        return date.replace(/\//g, "").replace(/:/g, "").replace(/ /g, "");
    };

    const ScanInfo = (scan_id) => {
        const selectedScanData = historyRecords.find(record => record.scan_id === scan_id);
        setScanInfoData(selectedScanData); // 設置需要顯示在 Modal 的數據
        toggleScanInfoModal(); // 開啟 Modal
    };

    const columns = [
        {
            name: '區網',
            selector: row => row.local_net_name,
            sortable: true,
            cell: row => (
                <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
                    {row.local_net_name}
                </div>
            )
        },
        {
            name: '單位',
            selector: row => row.local_unit_name,
            sortable: true,
            cell: row => (
                <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
                    {row.local_unit_name}
                </div>
            )
        },
        {
            name: '流水號',
            selector: row => {
                const newFormat = formatBuildDate(row.build_date);
                return `${newFormat}-${row.local_net_id}-${row.local_unit_id}-${row.serial_no}`;
            },
            sortable: true,
            cell: row => (
                <div style={{
                    whiteSpace: 'normal',
                    wordWrap: 'break-word'
                }}>
                    {formatBuildDate(row.build_date)}-{row.local_net_id}-{row.local_unit_id}-{row.serial_no}
                </div>
            )
        },
        { name: '主機名稱', selector: row => row.host_name, sortable: true },
        {
            name: '主機IP',
            selector: row => row.host_ip,
            sortable: true,
            cell: row => (
                <div style={{
                    whiteSpace: 'normal',
                    wordWrap: 'break-word'
                }}>
                    {row.host_ip}
                </div>
            )
        },
        { name: '狀態', selector: row => row.scan_status_description, sortable: true },
        { name: '主機用途', selector: row => row.host_os, sortable: true },
        { name: <RiskHeader title="重風險" color="purple" />, selector: row => row.heavy },
        { name: <RiskHeader title="高風險" color="red" />, selector: row => row.high, sortable: true },
        { name: <RiskHeader title="中風險" color="orange" />, selector: row => row.meddle },
        { name: <RiskHeader title="低風險" color="blue" />, selector: row => row.low },
        { name: <RiskHeader title="訊息" color="green" />, selector: row => row.message },
        { name: '建立人員', selector: row => row.build_id },
        {
            name: '操作',
            cell: row => {
                const originalFormat = row.build_date;
                const newFormat = originalFormat.replace(/[/: ]/g, "");
                const scanname = `${newFormat}-${row.local_net_id}-${row.local_unit_id}-${row.serial_no}`;

                // 判斷是否超過 3 年
                const scanDate = new Date(row.scan_start_time);
                const threeYearsAgo = new Date();
                threeYearsAgo.setFullYear(threeYearsAgo.getFullYear() - 3); // 設定為 3 年前的今天
                const isThreeYearsExpired = scanDate < threeYearsAgo;

                return (
                    <div>
                        {row.scan_status === "2" && (
                            <>
                                {row.downland_url ? (
                                    !isThreeYearsExpired ? (
                                        <Button
                                            type="button"
                                            className="btn btn-primary mx-1"
                                            onClick={() => DownLoadPaper(row.scan_id)}
                                        >
                                            下載報告
                                        </Button>
                                    ) : (
                                        <Button
                                            type="button"
                                            className="btn mx-1"
                                            style={{
                                                backgroundColor: "#ff4d4d",
                                                color: "white",
                                                padding: "10px 15px",
                                                borderRadius: "4px",
                                                fontWeight: "bold",
                                                fontSize: "16px",
                                                border: "none",
                                                cursor: "default"
                                            }}
                                            disabled
                                        >
                                            ⛔ 報告已過期
                                        </Button>
                                    )
                                ) : null}

                                {row.scan_status === "2" && row.downland_url && (
                                    <Button
                                        type="button"
                                        className="btn btn-secondary mx-1"
                                        onClick={() => handleShowPasswordModal(row.id, scanname, netName, unitName)}
                                    >
                                        寄送密碼
                                    </Button>
                                )}
                                <Button
                                    type="button"
                                    className='btn btn-secondary mx-1'
                                    onClick={() => ScanInfo(row.scan_id)}
                                >
                                    掃描資訊
                                </Button>
                            </>
                        )}
                    </div>
                );
            },
            sortable: false,
        }

    ];

    return (
        <div>
            <SiteTitle />
            <h2>歷史紀錄</h2>
            <div
                style={{
                    position: "relative",
                    width: "120%",        // 讓 DataTable 可以完整顯示
                    borderRadius: "inherit",
                    overflowX: "hidden",  // 隱藏超出的內容
                    overflowY: "hidden",
                    minHeight: "0",
                    right: "100px",       // 讓表格右移
                }}
            >
                <DataTable
                    columns={columns}
                    data={historyRecords}
                    pagination
                    highlightOnHover
                    noDataComponent="沒有紀錄顯示"
                    persistTableHead
                />
            </div>
            <Modal isOpen={isPasswordModalOpen} toggle={togglePasswordModal}>
                <ModalHeader toggle={togglePasswordModal}>寄送密碼</ModalHeader>
                <ModalBody>
                    {renderPasswordModalContent()}
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleSendReportPassword}>確認</Button>{' '}
                    <Button color="secondary" onClick={togglePasswordModal}>取消</Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={isScanInfoModalOpen} toggle={toggleScanInfoModal}>
                <ModalHeader toggle={toggleScanInfoModal}>掃描資訊</ModalHeader>
                <ModalBody>
                    {scanInfoData ? (
                        <>
                            <p><strong>申請掃描時間：</strong>{scanInfoData.scan_request_time}</p>
                            <p><strong>開始掃描時間：</strong>{scanInfoData.scan_start_time}</p>
                            <p><strong>結束掃描時間：</strong>{scanInfoData.scan_end_time}</p>
                            <p><strong>掃描使用時間：</strong>{scanInfoData.scan_duration}</p>
                        </>
                    ) : (
                        <p>無法取得掃描資訊。</p>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggleScanInfoModal}>關閉</Button>
                </ModalFooter>
            </Modal>

        </div>
    );
}

export default TenableHistoryData;
